const DEVICE_KEY = 'gwc.deviceId';

function newId(): string {
  return crypto.randomUUID();
}

/** Stable per-browser id for OTP verification and cookie consent. */
export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = newId();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return newId();
  }
}
